import { clearObject } from "@/functions/helpers.js";

export default {
  getCategories(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("courses/categories")
        .then(response => {
          context.commit("setCategories", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getAll(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/?${queryString}`)
        .then(response => {
          context.commit("setCourses", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getFeatured(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/filter/feature?limit=6")
        .then(response => {
          context.commit("setFeatured", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${id}`)
        .then(response => {
          context.commit("setCourse", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getArchives(context, { id, params }) {
    const queryString = new URLSearchParams(clearObject(params)).toString();

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/sources/${id}?${queryString}`)
        .then(response => {
          context.commit("setArchives", response.data.results);
          context.commit("setArchivesCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getLesson(context, { course_id, lesson_id }) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${course_id}/lesson/${lesson_id}`)
        .then(response => {
          context.commit("setLesson", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getLive(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/live")
        .then(response => {
          context.commit("setLive", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getLessons(context, { id, params }) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons/${id}?${queryString}`)
        .then(response => {
          context.commit("setLessons", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  },

  getFreebies(context, params) {
    const queryString = new URLSearchParams(params).toString();
    context.commit("setCount", 0);

    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons/free?${queryString}`)
        .then(response => {
          context.commit("setFreebies", response.data.results);
          context.commit("setCount", response.data.count);
          resolve();
        })
        .catch(reject);
    });
  }
};
